<template>
  <v-container class="pa-6" style="max-width: 720px">
    <v-card class="pa-4">
      <v-card-title class="text-h5">POLÍTICA DE PRIVACIDADE</v-card-title>
      <v-card-text>
        <h3>1. OBJETIVO DESTA POLÍTICA</h3>
        <p>
          REVOLUTION SOLUÇÕES TECNOLÓGICAS PARA O VAREJO LTDA.,
          doravante denominada REVOLUTION, empresa com sede em São
          Paulo/SP, inscrita no CNPJ sob o número 27.659.353/0001-54, é
          controladora dos dados pessoais dos usuários cadastrados na
          plataforma SCN. Emprega os melhores esforços para fornecer
          medidas de proteção adequadas em todas as suas operações e
          para implementar as políticas e os procedimentos mais
          consistentes, efetivos e rigorosos. Por reconhecer a
          importância da sua privacidade, desenvolvemos esta Política
          para informá-lo a respeito das condições sob as quais
          Tratamos e Protegemos seus Dados Pessoais. Esta Política
          também descreve seus direitos e como você pode entrar em
          contato conosco para exercê-los ou nos fazer quaisquer
          perguntas que você possa ter sobre a proteção de seus Dados
          Pessoais.
        </p>
        <p>
          Os termos dessa Política se aplicam aos Usuários e/ou
          Visitantes do website
          <a href="https://scnrevolution.com/" target="_blank" rel="noopener">https://scnrevolution.com/</a>
          ou
          <a href="https://app.scnrevolution.com/" target="_blank" rel="noopener">https://app.scnrevolution.com/</a>,
          também conhecidos como CANAIS DIGITAIS.
        </p>

        <h3>2. ORIGEM DOS DADOS PESSOAIS</h3>
        <p>A REVOLUTION coleta e trata os seus Dados Pessoais que poderão ser recebidos:</p>
        <ol>
          <li>ao fornecer informações, ao utilizar nossos sites e/ou App;</li>
          <li>pela empresa que contrata os serviços da REVOLUTION em seu benefício;</li>
          <li>por coleta automática ao navegar nos sites e/ou App; e</li>
          <li>por comunicação com outros usuários;</li>
          <li>por coleta de informações por meio de outras fontes confiáveis.</li>
        </ol>
        <p>As informações coletadas pela REVOLUTION incluem:</p>
        <ol>
          <li>sendo pessoa física: nome completo, e-mail, senha, número de telefone, endereço, CPF, profissão, foto, data de nascimento e RG.</li>
          <li>sendo pessoa jurídica: nome completo do representante, e-mail, senha, número de telefone, endereço, CPF, profissão, foto, data de nascimento e RG, CNPJ e endereço comercial.</li>
        </ol>

        <h3>3. FINALIDADES PARA AS QUAIS UTILIZAMOS DADOS PESSOAIS</h3>
        <p>
          Os Dados Pessoais que a REVOLUTION coleta são utilizados para
          fornecer os seus serviços, garantir que funcionem conforme o
          esperado, para aprimorá-los e, também, para ajudar a
          melhorar a confiabilidade e segurança de todos os nossos
          serviços.
        </p>
        <p>Especificamente, a REVOLUTION poderá utilizar seus Dados Pessoais para as seguintes finalidades:</p>
        <ol>
          <li>administrar, prestar os serviços e cumprir as obrigações decorrentes dos serviços disponibilizados pela REVOLUTION;</li>
          <li>informar sobre novidades, serviços, funcionalidades, conteúdos, benefícios, promoções, notícias e demais eventos relevantes e de relacionamento com os usuários;</li>
          <li>criação de plano de ação de melhoria de nossos serviços/produtos;</li>
          <li>colaborar e/ou cumprir ordem judicial ou requisição por autoridade administrativa;</li>
          <li>qualquer outra finalidade que será informada a você, se aplicável, quando coletamos seus dados.</li>
        </ol>
        <p>A REVOLUTION não vende e/ou comercializa informações que possam identificá-lo.</p>

        <h3>4. BASE LEGAL PARA O TRATAMENTO DE DADOS PESSOAIS</h3>
        <p>
          A REVOLUTION realiza o Tratamento dos Dados Pessoais como
          parte do desempenho e gestão de nosso relacionamento
          contratual com você e/ou com a empresa contratante dos
          nossos serviços, em nosso legítimo interesse ou de terceiros,
          desde que os requisitos legais para tanto sejam atendidos, em
          conformidade com certas obrigações legais ou regulatórias,
          ou quando for necessário para o exercício regular de
          direitos em processo judicial, administrativo ou arbitral.
          Seus Dados Pessoais também podem ser tratados com base em
          seu prévio consentimento, caso, sob certas circunstâncias,
          seu consentimento seja solicitado.
        </p>

        <h3>5. COMPARTILHAMENTO DE DADOS PESSOAIS</h3>
        <p>
          A segurança e a confidencialidade de seus Dados Pessoais são
          de grande importância para nós. É por isso que restringimos
          o acesso a seus Dados Pessoais somente aos nossos
          profissionais devidamente autorizados que precisem ter
          conhecimento sobre tais dados para processar seus pedidos ou
          fornecer o(s) serviço(s) solicitado(s).
        </p>
        <p>
          Não divulgaremos seus Dados Pessoais a terceiros não
          autorizados. No entanto, podemos compartilhar seus Dados
          Pessoais com entidades dentro do grupo (cliente) e com
          prestadores de serviços autorizados, com os quais trabalhamos
          (por exemplo: Call Center; agentes de relacionamento;
          serviços de BackOffice; consultores nas áreas de tecnologia e
          informática; etc.), a quem podemos recorrer com o propósito
          de prestar nossos serviços. Nesses casos, garantimos que os
          seus Dados Pessoais sejam tratados apenas para propósitos
          legítimos, específicos, explícitos e informados a você, sem
          possibilidade de Tratamento posterior de forma incompatível
          com a finalidade informada.
        </p>
        <p>Além disso, podemos compartilhar Dados Pessoais a seu respeito, quando acreditamos, de boa-fé, que temos a obrigação de:</p>
        <ol>
          <li>cumprir uma lei, regulamento ou ordem judicial;</li>
          <li>responder solicitações de informação feitas por órgão regulador, autoridade policial e demais autoridades públicas, inclusive em casos relativos à segurança nacional;</li>
          <li>fazer cumprir e/ou proteger propriedade ou direitos da REVOLUTION, inclusive para investigar fraudes e ajudar a prevenir ameaças de segurança, inclusive da informação, ou outras atividades criminosas ou maliciosas; ou</li>
          <li>proteger os interesses legítimos de terceiros, incluindo a segurança pessoal dos funcionários da REVOLUTION.</li>
        </ol>

        <h3>6. ARMAZENAMENTO DE SEUS DADOS PESSOAIS</h3>
        <p>
          Armazenamos seus Dados Pessoais em nossas bases, em ambiente
          seguro, garantindo o sigilo e a sua confidencialidade,
          somente pelo tempo necessário para cumprir as finalidades
          para as quais foram coletados, observados os eventuais
          prazos legais e a necessidade de defesa da REVOLUTION em
          possíveis processos. No entanto, eventualmente, podemos ter
          que manter os seus Dados Pessoais por um período superior,
          por motivo de leis ou regulamentos aplicáveis. Findo o prazo
          e a necessidade legal, os seus Dados Pessoais serão excluídos
          com uso de métodos de descarte seguro ou utilizados de forma
          anonimizada para fins estatísticos.
        </p>

        <h3>7. DADOS PESSOAIS SENSÍVEIS E DE CRIANÇAS E ADOLESCENTES</h3>
        <p>
          Caso seja estritamente necessário coletar tais dados para
          atingir a finalidade para a qual o tratamento é realizado, o
          faremos de acordo com as exigências legais locais para a
          proteção de Dados Pessoais e, em particular, com seu prévio
          consentimento específico e destacado, para finalidades
          específicas sob as condições descritas nesta Política.
        </p>

        <h3>8. TRANSFERÊNCIA INTERNACIONAL DE DADOS PESSOAIS</h3>
        <p>
          Como a REVOLUTION possui área de atuação aderente à área de
          atuação de seus CLIENTES, eventualmente, seus Dados Pessoais
          podem ser transferidos para destinatários localizados fora do
          Brasil e autorizados a realizar serviços em nosso nome. Na
          hipótese de transferência internacional com destinatários
          localizados em outros países, adotaremos as medidas
          necessárias para assegurar a existência de garantias
          adequadas para a proteção dos seus Dados Pessoais de acordo
          com a LGPD e em observância às proteções descritas na
          presente Política.
        </p>

        <h3>9. EXERCÍCIO DE SEUS DIREITOS DECORRENTES DA LGPD</h3>
        <p>
          A REVOLUTION respeita os direitos que você possui na
          qualidade de titular de Dados Pessoais e possibilita seu
          exercício em conformidade com o artigo 18 da Lei n.
          13.709/2018.
        </p>
        <p>
          Para exercer qualquer um dos seus direitos acima mencionados,
          veja a seção: 13. FALE CONOSCO SOBRE SEUS DIREITOS DECORRENTES
          DA LGPD.
        </p>
        <p>
          Para garantir a sua privacidade, e como medida de segurança e
          prevenção à fraude, podemos solicitar a comprovação da sua
          identidade antes de efetivarmos os seus direitos.
        </p>

        <h3>10. SEGURANÇA APLICÁVEL À PROTEÇÃO DE DADOS PESSOAIS</h3>
        <p>
          Implementamos as melhores práticas de mercado de segurança
          técnicas e administrativas possíveis para proteger os seus
          Dados Pessoais de acessos não autorizados e de situações
          acidentais ou ilícitas de destruição, perda, alteração,
          comunicação ou difusão, conforme determina a legislação
          vigente.
        </p>
        <p>
          No entanto, esteja ciente de que nenhuma empresa, incluindo o
          (cliente), pode eliminar totalmente os riscos de segurança
          associados ao Tratamento de Dados Pessoais. Para a sua
          segurança, é indispensável que você se proteja do acesso não
          autorizado à sua senha e ao seu computador, pois seu acesso é
          de uso pessoal e intransferível, sendo de sua única e
          exclusiva responsabilidade. Havendo tentativa de acesso
          indevido ou não autorizado, você deverá comunicar a
          REVOLUTION o mais rápido possível.
        </p>

        <h3>11. ACESSOS E ATUALIZAÇÕES DA NOSSA POLÍTICA DE PRIVACIDADE</h3>
        <p>Ao acessar o site da REVOLUTION, você concorda expressamente com esta Política.</p>
        <p>
          Para sua própria segurança, você deverá ler, certificar-se de
          haver entendido todas as condições estabelecidas nesta
          Política, assim como nos demais documentos a ela
          incorporados por referência.
        </p>
        <p>
          Ao aceitar os termos dessa Política, você concorda
          expressamente em fornecer somente Dados Pessoais verdadeiros,
          atuais e precisos. Você será o único responsável pelas
          informações falsas, desatualizadas ou imprecisas que fornece
          diretamente para a REVOLUTION.
        </p>
        <p>
          Caso ocorra qualquer alteração na presente Política,
          publicaremos a nova versão por meio de um link e enviaremos a
          todos os clientes por e-mail, na qual indicará a data em que
          se deu a revisão, para que você possa estar sempre ciente do
          conteúdo atualizado.
        </p>
        <p>
          Todas as modificações entrarão em vigor imediatamente após a
          publicação da Política de Privacidade revisada, a menos que
          especificado de outra forma. Assim, recomendamos que você
          consulte periodicamente esta Política, a fim de cientificar
          sobre as respectivas alterações.
        </p>
        <p>
          A data da última atualização desta Política é indicada no
          final deste documento e reflete a data efetiva desta
          Política. As versões anteriores desta Política poderão ser
          solicitadas pelo e-mail indicado nesta política.
        </p>

        <h3>12. LEI APLICÁVEL E JURISDIÇÃO</h3>
        <p>
          A presente Política de Privacidade será regida, interpretada
          e executada segundo a legislação brasileira, no idioma
          português, sendo eleito o Foro da Comarca de São Paulo/SP
          para dirimir qualquer litígio ou controvérsia envolvendo o
          presente documento, salvo ressalva específica de competência
          pessoal, territorial ou funcional pela legislação aplicável.
          Fora do Estado, a JUSPRO – Justiça Sem Processo Mediação e
          Conciliação S/S Ltda. como Câmara de Mediação apta a dirimir
          as questões envolvendo os Usuários titulares dos dados, nos
          termos do artigo 52, §7º da Lei Geral de Proteção de Dados.
        </p>

        <h3>13. FALE CONOSCO SOBRE SEUS DIREITOS DECORRENTES DA LGPD</h3>
        <p>
          A REVOLUTION possui um corpo técnico, especializado e
          responsável por encarregar-se dos Dados de todo este novo
          processo e estarão à frente das novas práticas que passarão
          a ser adotadas pelas empresas do GRUPO, que serão
          implementadas a partir de junho de 2024, sempre objetivando a
          manutenção da SEGURANÇA DOS DADOS adotados pela companhia.
          Linha direta pelo telefone (11) 98988-4869 ou e-mail:
          <a href="mailto:lgpd@scnrevolution.com">lgpd@scnrevolution.com</a>.
        </p>
        <p>
          Para o exercício de qualquer um dos seus direitos mencionados
          na seção 09 da presente Política, por exemplo, direito de
          acesso ou correção dos seus Dados Pessoais, envie a sua
          solicitação para o seguinte endereço: Av. Paulista 1471,
          Conjunto 511 – Bela Vista, CEP: 01.311-927 – São Paulo/SP, ou
          por e-mail
          <a href="mailto:lgpd@scnrevolution.com">lgpd@scnrevolution.com</a>
          com o assunto: "LGPD - DPO (cliente)", se por carta, a
          informação deverá ser encaminhada com comprovante de
          recebimento (AR).
        </p>
        <p>
          Se você tiver alguma dúvida sobre esta Política de
          Privacidade ou sobre nossas práticas em relação à privacidade,
          entre em contato com o nosso Encarregado de Proteção de Dados
          do Grupo através do seguinte endereço de e-mail:
          <a href="mailto:lgpd@scnrevolution.com">lgpd@scnrevolution.com</a>.
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyPolicy"
};
</script>
